<template>
  <component
    :variables="variables"
    v-if="
      data.is_static === true &&
      $options.components[data.page_name] !== undefined
    "
    v-bind:is="data.page_name"
  >
  </component>

  <div v-else-if="data.is_static === true">Unknown static component</div>

  <DynamicPageManager
    v-else-if="data.is_static === false"
    :data="data"
    :variables="variables"
    :language="dataLanguageCode"
  />
</template>

<script>
import getEnv from '@/utils/env';
import DynamicPageManager from '@/components/page-loading-components/DynamicPageManager';

const qs = require('querystring-browser');

export default {
  name: 'PageLoader',
  components: {
    DynamicPageManager,
    AdminPanel: () => import('@/components/AdminPanel'),
    PageForm: () => import('@/components/forms/PageForm'),
    SectionFormManager: () => import('@/components/SectionFormManager'),
    TableForm: () => import('@/components/forms/TableForm'),
    ArticleForm: () => import('@/components/forms/ArticleForm'),
    DataSeriesForm: () => import('@/components/forms/DataSeriesForm'),
  },
  props: ['languageCode'],
  data() {
    return {
      data: {},
      variables: {},
      dataLanguageCode: this.languageCode,
      currentRouteRendering: null,
    };
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.params.languageCode) {
      this.dataLanguageCode = to.params.languageCode;
    }
    this.initVariables(to.params.languageCode);
    await this.getPage(to.path);
    next();
  },
  // eslint-disable-next-line no-unused-vars
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.initVariables(to.params.languageCode);
      await vm.getPage(to.path);
      if (vm.data.page_name) {
        if (
          vm.data.page_content &&
          vm.data.page_content[to.params.languageCode]
        ) {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            vm.data.page_content[to.params.languageCode].title
          }`;
        } else if (vm.data.page_content && vm.data.page_content.en) {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            vm.data.page_content.en.title
          }`;
        } else {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            vm.data.page_name
          }`;
        }
        if (
          getEnv('VUE_APP_PAGE_TITLE_PREFIX') === 'Ifeane' &&
          document.getElementById('favicon')
        ) {
          document.getElementById('favicon').href =
            '/static/ifeane-favicon.png';
        } else if (
          getEnv('VUE_APP_PAGE_TITLE_PREFIX') === 'Tranzai' &&
          document.getElementById('favicon')
        ) {
          document.getElementById('favicon').href =
            '/static/tranzai-favicon.png';
        } else {
          document.getElementById('favicon').href =
            '/static/comfiz-favicon.png';
        }
      }
    });
  },
  async mounted() {
    this.dataLanguageCode = this.languageCode;
    this.initVariables(this.dataLanguageCode);
    await this.getPage(this.$router.currentRoute.path);
  },
  methods: {
    initVariables(languageCode) {
      this.data = {};
      if (languageCode) {
        this.dataLanguageCode = languageCode;
      }
    },
    async getPage(path) {
      if (this.currentRouteRendering === this.$router.currentRoute.fullPath) {
        return;
      }
      this.currentRouteRendering = this.$router.currentRoute.fullPath;
      let res = {};
      try {
        res = await this.$cmsUtils.getPageRendering(qs.escape(path));
        if (res && res.variables) {
          this.variables = res.variables;
        }
        // if (res && res.page_id) {
        //   this.$cmsConsts
        //     .getUrlByPageId(
        //       this.dataLanguageCode ? this.dataLanguageCode : 'en',
        //       res.page_id
        //     )
        //     .then((res_url) => {
        //       if (res_url !== path) {
        //         // eslint-disable-next-line
        //         console.error(
        //           `Different route for response page : ${res_url} instead of ${path}`
        //         );
        //         this.$router.push(res_url);
        //       }
        //     });
        // }
        if (!res || !res.page_content || res.error === 'Invalid token') {
          const url = await this.$cmsConsts.getUrlByPageId(
            this.dataLanguageCode ? this.dataLanguageCode : 'en',
            this.$getEnv('VUE_APP_LOGIN')
          );
          if (url !== this.$route.path) {
            this.$router.push(url);
          }
          return;
        }
        if (!res.page_content[this.dataLanguageCode]) {
          this.$cmsConsts.notificationError(
            'Page not available in selected language'
          );
          const url = await this.$cmsConsts.getUrlByPageId('en', res);
          if (url !== this.$route.path) {
            this.$router.push(url);
          }
          return;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
      this.data = res;
      // if ((this.data.page_content || this.data.page_name) && !this.entityId) {
      if (this.data.page_content || this.data.page_name) {
        if (
          this.data.page_content &&
          this.data.page_content[this.dataLanguageCode]
        ) {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            this.data.page_content[this.dataLanguageCode].title
          }`;
        } else if (this.data.page_content && this.data.page_content.en) {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            this.data.page_content.en.title
          }`;
        } else {
          document.title = `${getEnv('VUE_APP_PAGE_TITLE_PREFIX')} - ${
            this.data.page_name
          }`;
        }
      }
      if (this.dataPageTypeUrl === 'admin') {
        document.body.style['background-color'] = '#f9f9f9';
      }
    },
  },
  watch: {
    async $route() {
      this.getPage(this.$router.currentRoute.path);
    },
  },
};
</script>
